import { successAction } from '@utils/actions';
import { FLAGS_UPDATED } from '../types/fwf';

// Initial State
export const model = {
  flags: {},
};

const fwfReducer = (state = model, { type, payload } = {}) => {
  if (type === successAction(FLAGS_UPDATED)) {
    const { flags } = payload;
    return {
      ...state,
      flags: {
        ...state.flags,
        ...flags,
      },
    };
  }
  return state;
};

export default fwfReducer;
